import { render, staticRenderFns } from "./address-add-or-update.vue?vue&type=template&id=164adee6&"
import script from "./address-add-or-update.vue?vue&type=script&lang=js&"
export * from "./address-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports